<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="59.397" height="59.397" viewBox="0 0 59.397 59.397">
        <g id="Groupe_2" data-name="Groupe 2" transform="translate(-1726.42 -54.802)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="73" height="11" transform="translate(1726.42 106.42) rotate(-45)" :fill="color" />
            <rect id="Rectangle_42" data-name="Rectangle 42" width="73" height="11" transform="translate(1778.039 114.198) rotate(-135)" :fill="color" />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Close",
    props: ["color"],
};
</script>

<style scoped></style>
